import React from 'react';
import { Box, Typography } from '@mui/material';

export default function Index() {
    return (
        <>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                minHeight: 'calc(100% - 64px)',
            }}>
                <Typography component={'div'}>
                    Let&apos;s get started! Create a show, season, or episode using the menu.
                    Or select an existing show, season, and episode from the menu.
                </Typography>
            </Box>
        </>
    )
}